/**
 * ics: i车币相关接口
 */
import { request } from './api';
import config from '../config/index';
import * as constNames from '../services/const.service';
const appId = 'dealer.icsTast';
function headersToken() {
  return {
    headers: {
      Authorization: `signature ${sessionStorage.getItem(
        constNames.TOKEN_KEY,
      )}`,
    },
  };
}
export default {
  /**
   * i车币获取来源-前端上报操作日志接口
   * api地址： http://doc.phonebus.corpautohome.com/project/900/interface/api/45587
   * @param appId  appId
   * @param taskId  店铺id
   *  taskId，前端可通过判断相关点击事件来确定taskId，
      100101：通话大于等于30s且使用了带看工具；                        
      100102：通话大于等于30s且使用留资工具；
   * @param channelId 带看编号
   * @param eventCode事件码
   */
  getCoinCeportOpt({ channelId, taskId, eventCode }) {
    const url = `${config.vrtake}/api/car/coin/reportOpt?_appId=${appId}&channelId=${channelId}&taskId=${taskId}&eventCode=${eventCode}`;
    return request({
      type: 'post',
      url,
      crossDomain: true,
      xhrFields: { withCredentials: true },
      dataType: 'json',
      contentType: 'application/json;charset=UTF-8',
    });
  },
  /**
   * 每日常规车币明细
   * api地址： http://doc.phonebus.corpautohome.com/project/900/interface/api/45763
   * @param appId appId
   * @param saleId 顾问id
   * @param pageIndex
   * @param pageSize
   */
  saleCoinListForDay({ salesId, pageIndex, pageSize }) {
    const url = config.vrtake + '/api/car/coin/saleCoinList';
    return request({
      type: 'get',
      url: url,
      ...headersToken(),
      data: { _appId: appId, saleId: salesId, pageIndex, pageSize },
    });
  },
  /**
   * 总车币接口
   * api地址：http://doc.phonebus.corpautohome.com/project/900/interface/api/45819
   * @param appId  appId
   * @param saleId 顾问id
   */
  getSaleCoinTotal(salesId) {
    const url = config.vrtake + '/api/car/coin/saleCoinTotal';
    return request({
      type: 'get',
      url: url,
      ...headersToken(),
      data: { _appId: appId, saleId: salesId },
    });
  },
  /**
   *  月度激励车币明细列表接口,
   * api地址：http://doc.phonebus.corpautohome.com/project/900/interface/api/45955
   * @param appId  appId
   * @param saleId 顾问id
   */
  getSaleMonthCoinList(saleId) {
    const url = config.vrtake + '/api/car/coin/saleMonthCoinList';
    return request({
      type: 'get',
      url: url,
      ...headersToken(),
      data: { _appId: appId, saleId },
    });
  },
};
